/**
 * Created by andermurias on 25/6/17.
 */
import React, { Component } from 'react';

import '../../styles/elements/networkList.css';

class NetworkList extends Component {
    render() {
        return (
            <ul className={'network-list' + (this.props.className ? ' ' + this.props.className : '')}>
                {this.props.networks.map((network, i) => {
                    return <li className="network-list__network" key={'mcn' + i}>
                        <a href={network.url} target="_blank" rel="noopener noreferrer"
                           className="network-list__network-link"
                           key={'mcnl' + i}>
                            <i className={'fa ' + network.icon} aria-hidden="true"
                               key={'nwl' + i}></i>
                        </a>
                    </li>
                })}
            </ul>
        )
    }



}

export default NetworkList;






// WEBPACK FOOTER //
// ./src/js/elements/NetworkList.js